import { render, staticRenderFns } from "./Berita.vue?vue&type=template&id=b7536f06&"
import script from "./Berita.vue?vue&type=script&lang=js&"
export * from "./Berita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports